var _rect, _path, _path2, _path3, _path4, _path5, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCroatia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_694_2827)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.2002 11.6667H20.1998V17.0001H-2.2002V11.6667Z",
    fill: "#1A47B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.2002 1H20.1998V6.33333H-2.2002V1Z",
    fill: "#F93939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3335 5.26662H7.40016V6.33328H6.3335V5.26662ZM8.46683 4.19995H9.5335V6.33328H8.46683V4.19995ZM10.6002 5.26662H11.6668V6.33328H10.6002V5.26662Z",
    fill: "#3A99FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53324 4.19995H10.5999V6.33328H9.53324V4.19995ZM7.3999 4.19995H8.46657V6.33328H7.3999V4.19995Z",
    fill: "#1A47B8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_694_2827",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 6,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 10.0666C11.6668 11.5386 10.4722 12.7333 9.00016 12.7333C7.52816 12.7333 6.3335 11.5386 6.3335 10.0666V6.33325H11.6668V10.0666Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_694_2827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 10.0666C11.6668 11.5386 10.4722 12.7333 9.00016 12.7333C7.52816 12.7333 6.3335 11.5386 6.3335 10.0666V6.33325H11.6668V10.0666Z",
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40016 11.6666H8.46683V12.7333H7.40016V11.6666ZM9.5335 11.6666H10.6002V12.7333H9.5335V11.6666ZM8.46683 10.5999H9.5335V11.6666H8.46683V10.5999ZM7.40016 9.53325H8.46683V10.5999H7.40016V9.53325ZM9.5335 9.53325H10.6002V10.5999H9.5335V9.53325ZM8.46683 8.46659H9.5335V9.53325H8.46683V8.46659ZM7.40016 7.39992H8.46683V8.46659H7.40016V7.39992ZM9.5335 7.39992H10.6002V8.46659H9.5335V7.39992ZM8.46683 6.33325H9.5335V7.39992H8.46683V6.33325ZM10.6002 6.33325H11.6668V7.39992H10.6002V6.33325ZM10.6002 8.46659H11.6668V9.53325H10.6002V8.46659ZM10.6002 10.5999H11.6668V11.6666H10.6002V10.5999ZM6.3335 10.5999H7.40016V11.6666H6.3335V10.5999ZM6.3335 8.46659H7.40016V9.53325H6.3335V8.46659ZM6.3335 6.33325H7.40016V7.39992H6.3335V6.33325Z",
    fill: "white"
  })))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    rx: 8.5,
    stroke: "#EEEEEE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_694_2827"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCroatia);
export default __webpack_public_path__ + "static/media/croatia.73451c15ecd40a3b2f02ea4440be560c.svg";
export { ForwardRef as ReactComponent };